import { ADALONG_COLORS, ThemeStyle } from '@src/styles';
import React, { FC } from 'react';
import { style } from 'typestyle';
import { ConversationMessage } from 'common';
import dayjs from 'dayjs';

// Component to preview lookaside CDN content (video or image)
const LookasidePreview: FC<{ url: string }> = ({ url }) => {
  const [errored, setErrored] = React.useState(false);

  // Try video first, fallback to image if error
  if (!errored) {
    return (
      <video
        src={url}
        controls
        className={mediaStyles}
        onError={() => setErrored(true)}
      />
    );
  }
  // If video fails, try image
  return (
    <img
      src={url}
      alt="media preview"
      className={mediaStyles}
      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
    />
  );
};

  const mediaStyles = style({
    width: '100%',
    maxWidth: 280,
    maxHeight: 320,
    borderRadius: '12px',
    display: 'block'
  });

export function Message(props: {
  message: ConversationMessage;
  senderInfo: { name: string };
  self: boolean;
}) {
  // Use only receivedDate for consistency; remove created_at reference to fix lint error
  const date = dayjs(props.message.receivedDate);
  const formattedHour = date.format('HH:mm');
  // Detect if the message is a lookaside CDN link
  const lookasidePrefix = "https://lookaside.fbsbx.com/ig_messaging_cdn/";
  const isLookaside = props.message.message.startsWith(lookasidePrefix);

  // Align: self (my) messages to right, others to left (Instagram style)
  const alignment = props.self ? 'flex-end' : 'flex-start';

  const messageContainerClass = style({
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignment,
    margin: '4px 0',
    width: '100%',
  });

  const messageBubbleClass = style({
    maxWidth: '70%',
    padding: '12px 16px',
    borderRadius: props.self ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
    backgroundColor: props.self ? ADALONG_COLORS.FLASH_BLUE : ADALONG_COLORS.SMOOTH_WHITE,
    color: props.self ? ADALONG_COLORS.LIGHT_WHITE : ADALONG_COLORS.DARK_BLACK,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    wordWrap: 'break-word',
    position: 'relative',
  });

  const messageTextClass = style({
    fontSize: '15px',
    lineHeight: '1.4'
  });

  const timestampClass = style({
    fontSize: '11px',
    color: '#65676b',
    marginTop: '2px',
    alignSelf: alignment,
    padding: props.self ? '0 16px 0 0' : '0 0 0 16px',
  });

  let content: React.ReactNode;
  if (isLookaside) {
    // Try to display as video, fallback to image if error
    content = (
      <LookasidePreview url={props.message.message} />
    );
  } else {
    content = <div className={messageTextClass}>{props.message.message}</div>;
  }

  return (
    <div className={messageContainerClass}>
      <div className={messageBubbleClass}>
        {content}
      </div>
      
      <div className={timestampClass}>
        {formattedHour}
      </div>
    </div>
  );
}
